<template>
  <router-link class="cus-link" :to="'/dashboard/customers/' + id">
    <slot v-if="$slots.content" name="content"></slot>
    <span v-else>{{ name }}</span>
  </router-link>
</template>
<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    origin: {
      type: Number,
      default: 0,
    },
  },
}
</script>
<style scoped>
.cus-link {
  display: inline-block;
  line-height: 1.4em;
}
</style>